module.exports = __webpack_public_path__ + "img/project9_13.png.e499cfeb.webp";